// extracted by mini-css-extract-plugin
export default {"Text":"_3yC8D","text-card-textarea":"_3KwDU","text-card-markdown":"_1J_Mq","single-row":"_3guoQ"};